const NotFound = () => {
    return (
        <main className="d-flex justify-content-center align-items-center flex-column" style={{ flex: '1', height: "100%" }}>
            <h1>404 Not found</h1>
            <p><i>This page may be under construction.</i></p>
        </main>
    );
}

export default NotFound;